import { hasMultiItemCartShops } from '../../experiments/shops'

export function updateCartStorage(userId, cartValue) {
  const key = 'pp-shops-cart-' + userId
  localStorage.setItem(key, cartValue)
}

export function getCartStorage(userId) {
  const key = 'pp-shops-cart-' + userId
  return localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : {}
}

export function removeCartStorage(userId) {
  const key = 'pp-shops-cart-' + userId
  localStorage.removeItem(key)
}

/**
 * This product will return the correct way to format productId and productQuantity information
 * mainly for planning call.
 */
export function handleProductDetails(
  ppshopsGuestId = '',
  sellerId = '',
  productId = '',
  productQuantity = ''
) {
  const cart = ppshopsGuestId ? getCartStorage(ppshopsGuestId) : undefined
  if (hasMultiItemCartShops() && cart) {
    try {
      return cart[sellerId].map(product => ({
        id: product.productId,
        quantity: product.quantity,
      }))
    } catch (ex) {
      return { id: '', quantity: '' }
    }
  }
  return {
    id: productId,
    quantity: productQuantity,
  }
}
